import { useState } from 'react';
import { platformApi } from './platformApi.js';
import { Button } from '@/components/ui/Button.jsx';
import { Input } from '@/components/ui/Input.jsx';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/Card.jsx';

export default function SecurityPage() {
  const [form, setForm] = useState({ currentPassword: '', newPassword: '', confirmPassword: '' });
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  function update(name, value) { setForm((current) => ({ ...current, [name]: value })); }

  async function submit(event) {
    event.preventDefault();
    setMessage('');
    setError('');
    setSaving(true);
    try {
      await platformApi.changePassword(form);
      setForm({ currentPassword: '', newPassword: '', confirmPassword: '' });
      setMessage('Password updated successfully. Other admin sessions were signed out.');
    } catch (err) {
      const messages = {
        platform_current_password_invalid: 'Current password is incorrect.',
        platform_password_confirmation_mismatch: 'New password confirmation does not match.',
        platform_password_must_change: 'New password must be different from the current password.',
      };
      setError(messages[err.message] || err.message || 'Could not update password.');
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="max-w-xl space-y-4">
      <div>
        <h1 className="text-lg font-semibold text-slate-900 dark:text-slate-100">Security</h1>
        <p className="text-sm text-slate-500">Change your platform administrator password.</p>
      </div>
      <Card>
        <CardHeader><CardTitle>Change password</CardTitle></CardHeader>
        <CardContent>
          <form onSubmit={submit} className="space-y-4">
            {[
              ['currentPassword', 'Current password'],
              ['newPassword', 'New password'],
              ['confirmPassword', 'Confirm new password'],
            ].map(([name, label]) => (
              <div key={name} className="space-y-1">
                <label className="text-sm font-medium text-slate-700 dark:text-slate-300">{label}</label>
                <Input type="password" value={form[name]} onChange={(event) => update(name, event.target.value)} autoComplete={name === 'currentPassword' ? 'current-password' : 'new-password'} required />
              </div>
            ))}
            <p className="text-xs text-slate-500">Changing the password signs out other active platform sessions.</p>
            {error && <p className="text-sm text-red-600">{error}</p>}
            {message && <p className="text-sm text-green-600">{message}</p>}
            <Button type="submit" disabled={saving}>{saving ? 'Updating…' : 'Update password'}</Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}